import { HttpBackend, HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable  } from 'rxjs';
import { map } from 'rxjs/operators'
import { EnvService } from '../../../core/env.service';
import { RuleAppliedPropertyDTO  } from '../../model/RuleAppliedPropertyDTO';
import { RuleAppliedDTO  } from '../../model/RuleAppliedDTO';
import { FilterResultDTO } from '../../model/FilterResultDTO';
import { FilterDTO } from '../../model/FilterDTO';
import { QueryBuilderFilterRuleDTO } from '../../model/QueryBuilderFilterRuleDTO';
import { AuthService } from 'src/app/core/auth-service.component';
import { OptionDTO } from '../../model/OptionDTO';


import { from, switchMap } from 'rxjs';

// var observableFromPromise =  from(promiseSrc);

@Injectable()
export class InvoiceManagementService {
    constructor(private _httpClient: HttpClient,public _env: EnvService,
        private _httpClientBackend: HttpClient,
        private _httpHandler: HttpBackend,private _authService: AuthService) {
            this._httpClientBackend = new HttpClient(_httpHandler);
    }

    GetUnAppliedRules(): Observable<Array<RuleAppliedPropertyDTO>> {
        return this._httpClient.get<Array<RuleAppliedPropertyDTO>>(this._env.apiRule +'InvoiceManagement/GetUnAppliedRules')
        .pipe(map((res: Array<RuleAppliedPropertyDTO>) => res));
    }

    GetClientCodeName(page:number, pageSize:number): Observable<Array<OptionDTO>> {

        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetClientId?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
       
    }

    GetClientCodeNameByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetClientIdByFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }));        
    }

    GetClientDivision(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(
            switchMap((token)=>
            {
                return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetClientDiv?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
                .pipe(map((res: Array<OptionDTO>) => res));
            })  
        );
    }

    GetClientDivisionFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>{
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetClientDivFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }));
    }

    GetClientSubDivision(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetClientSubDiv?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetClientSubDivisionFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetClientSubDivFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        })  )  
    }

    GetClientLocation(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetClientLoc?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetClientLocationFilter(page:number, pageSize:number,filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetClientLocFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetClientSubLocation(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetClientSubLoc?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    
    GetClientSubLocationFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetClientSubLocFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetClientCountryCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetClientCountry?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetClientCountryCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetClientCountryFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCarrierCodeName(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetCarrierId?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCarrierCodeNameFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetCarrierIdFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCarrierLocation(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetCarrierLoc?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    
    GetCarrierLocationFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetCarrierLocFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCarrierCurrency(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetCarrierCurrency?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCarrierCurrencyFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetCarrierCurrencyFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCarrierCountryCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetCarrierCountry?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCarrierCountryCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetCarrierCountryFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetShipMode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetShipmentMode?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetShipModeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetShipmentModeFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetSrvceType(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetServiceType?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetSrvceTypeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetServiceTypeFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetFreightTerm(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetFreightTerms?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetFreightTermFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetFreightTermsFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCountryCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetCountry?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCountryCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetCountryFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetGeoPortCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetPortCode?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetGeoPortCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetPortCodeFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetAccessorialName(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetAccessorial?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
        
    }

    
    GetAccessorialNameFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'InvoiceManagement/GetAccessorialFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
        
        
    }

    GetAppliedRulesByFilterId(filterId:Number): Observable<Array<RuleAppliedDTO>> {
        return this._httpClient.get<Array<RuleAppliedDTO>>(this._env.apiRule +'InvoiceManagement/GetAppliedRulesByFilterId?filterId='+filterId)
        .pipe(map((res: Array<RuleAppliedDTO>) => res));
    }

    SaveAppliedRules(data:Array<RuleAppliedDTO>):Observable<Array<RuleAppliedDTO>> {
        return this._httpClient.post<Array<RuleAppliedDTO>>(this._env.apiRule +'InvoiceManagement/AdddRuleApplied',data)
        .pipe(map((res: Array<RuleAppliedDTO>) => res));
    }   
    
    SaveAppliedProperties(data:Array<RuleAppliedPropertyDTO>):Observable<Array<RuleAppliedPropertyDTO>> {
        return this._httpClient.post<Array<RuleAppliedPropertyDTO>>(this._env.apiRule +'InvoiceManagement/AddRuleProperties',data)
        .pipe(map((res: Array<RuleAppliedPropertyDTO>) => res));
    }   

    GetFilters(page:Number,pageSize:Number): Observable<FilterResultDTO> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClient.get<FilterResultDTO>(this._env.apiRule +'InvoiceManagement/GetFilter?page='+page+'&&pageSize='+pageSize, {headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: FilterResultDTO) => res));
        }))
    }

    GetFilterById(id: Number) {
        return this._httpClient.get<FilterDTO>(this._env.apiRule +'InvoiceManagement/GetFilterById?id='+id)
        .pipe(map((res: FilterDTO) => res)); 
    }

    GetFilterLineWithChild(id: Number) {
        return this._httpClient.get<any>(this._env.apiRule +'InvoiceManagement/GetFilterLineById?id='+id)
        .pipe(map((res: any) => res));
    }

    SaveFilter(data:FilterDTO): Observable<any> {
        return this._httpClient.post<FilterDTO>(this._env.apiRule +'InvoiceManagement/SaveFilter',data)
        .pipe(map((res: any) => res));
    }
    SaveFilterLine(data:QueryBuilderFilterRuleDTO): Observable<QueryBuilderFilterRuleDTO> {
        return this._httpClient.post<QueryBuilderFilterRuleDTO>(this._env.apiRule +'InvoiceManagement/SaveFilterLine',data)
        .pipe(map((res: QueryBuilderFilterRuleDTO) => res));
    }

    UpdateFilter(data:FilterDTO): Observable<FilterDTO> {
        return this._httpClient.post<FilterDTO>(this._env.apiRule +'InvoiceManagement/UpdateFilter',data)
        .pipe(map((res: FilterDTO) => res));
    }


    MassDeleteRulesList(data:Array<Number>):Observable<Array<Number>> {
        return this._httpClient.post<Array<Number>>(this._env.apiRule +'InvoiceManagement/MassDeleteRulist',data)
        .pipe(map((res: Array<Number>) => res));
    }
}